export default __webpack_public_path__ + "static/media/Section4-sub1.ee5a1688.svg";